export default function LoaderBar() {
  return(
    <div className="loader-wrapper">
      <div className="loader">
        <div className="loader-bar"></div>
      </div>
    </div>
  )
}